import classNames from 'classnames/bind'
import {format} from 'date-fns'

import {formatAmount} from '$utils/formatAmount'

import Styles from './InsuranceDetailInfoBox.module.scss'

const cx = classNames.bind(Styles)

const InsuranceDetailHeadLineArticleWrapper = ({children}: {children: React.ReactNode}) => {
    return <div className={cx('article')}>{children}</div>
}

export const FreeCoverageDetailBox = ({coverageNumber}: {coverageNumber: number}) => {
    return (
        <InsuranceDetailHeadLineArticleWrapper>
            <p className={cx('text')}>
                <em className={cx('emphasis')}>{coverageNumber}개 항목을 보장</em>받을 수 있습니다.
            </p>
        </InsuranceDetailHeadLineArticleWrapper>
    )
}
interface InsuranceGeneralFeeHeadLineBoxProps {
    endDate: Date
    age: number
    cycle: string
    amt: string
    comments: string[]
    계피상이보험여부?: boolean
}
export const InsuranceGeneralFeeHeadLineBox = ({
    endDate,
    age,
    cycle,
    amt,
    comments,
    계피상이보험여부,
}: InsuranceGeneralFeeHeadLineBoxProps) => {
    return (
        <InsuranceDetailHeadLineArticleWrapper>
            <p className={cx('text')}>
                {계피상이보험여부 ? (
                    <>
                        {format(endDate, 'yyyy년 MM월 dd일')}까지
                        <br />
                        <em className={cx('emphasis')}>
                            {cycle} 약 {amt}을 납입
                        </em>
                    </>
                ) : (
                    <>
                        {format(endDate, 'yyyy년 MM월')},{' '}
                        <em className={cx('emphasis')}>
                            {age}세까지
                            <br />
                            {cycle} 약 {amt}을 납입
                        </em>
                    </>
                )}
                해야 합니다.
                {comments.map((comment, idx) => (
                    <span key={idx} className={cx('sub')}>
                        {comment}
                    </span>
                ))}
            </p>
        </InsuranceDetailHeadLineArticleWrapper>
    )
}

export const InsuranceGeneralFeeHeadLineBoxEnd = ({totalAmt}: {totalAmt: number}) => {
    if (totalAmt === 0) {
        return null
    }
    return (
        <InsuranceDetailHeadLineArticleWrapper>
            <p className={cx('text')}>
                <em className={cx('emphasis')}>총 보험료 {formatAmount(totalAmt)} 납입을 끝냈습니다.</em>
                <br />
                축하드려요!
            </p>
        </InsuranceDetailHeadLineArticleWrapper>
    )
}

interface InsuranceGeneralCoverageHeadLineBoxProps {
    endDate: Date
    age: number
    coverageCnt: number
    isShowComment: boolean
    종신보험여부: boolean
}
// TODO : 계약자 === 피보험자 케이스만 구현, 계피상이는 설계 고민
export const InsuranceGeneralCoverageHeadLineBox = ({
    endDate,
    age,
    coverageCnt,
    isShowComment,
    종신보험여부,
}: Partial<InsuranceGeneralCoverageHeadLineBoxProps>) => {
    return (
        <InsuranceDetailHeadLineArticleWrapper>
            <p className={cx('text')}>
                최대 {endDate && format(endDate, 'yyyy년 MM월')}{' '}
                <em className={cx('emphasis')}>
                    {종신보험여부 ? '종신' : `${age}세`}까지
                    <br />
                    {coverageCnt}개 항목을 보장
                </em>
                받을 수 있습니다.
                {isShowComment && <span className={cx('sub')}>보장별 보장기간이 다를 수 있습니다.</span>}
            </p>
        </InsuranceDetailHeadLineArticleWrapper>
    )
}

export const InsuranceGeneralCoverageHeadLineBoxWithoutHolder = ({
    endDate,
    coverageCnt,
    isShowComment,
}: Partial<Omit<InsuranceGeneralCoverageHeadLineBoxProps, 'age' | '종신보험여부'>>) => {
    return (
        <InsuranceDetailHeadLineArticleWrapper>
            <p className={cx('text')}>
                최대 {endDate && format(endDate, 'yyyy년 MM월 dd일')} 까지
                <br />
                <em className={cx('emphasis')}>{coverageCnt}개 항목을 보장</em>
                받을 수 있습니다.
                {isShowComment && <span className={cx('sub')}>보장별 보장기간이 다를 수 있습니다.</span>}
            </p>
        </InsuranceDetailHeadLineArticleWrapper>
    )
}

export const InsuranceGeneralCoverageHeadLineBoxEnd = ({
    endDate,
}: Partial<Pick<InsuranceGeneralCoverageHeadLineBoxProps, 'endDate'>>) => {
    return (
        <InsuranceDetailHeadLineArticleWrapper>
            <p className={cx('text')}>{endDate && format(endDate, 'yyyy년 MM월')}에 보장이 종료되었습니다.</p>
        </InsuranceDetailHeadLineArticleWrapper>
    )
}

export const InsuranceCarFeeBox = ({faceAmt}: {faceAmt?: number}) => {
    if (faceAmt === undefined) {
        return null
    }

    const isIncrease = faceAmt > 0

    return (
        <InsuranceDetailHeadLineArticleWrapper>
            <p className={cx('text')}>
                이번에 납입한 보험료가 이전보다
                <br />
                <em className={cx('emphasis')}>
                    {formatAmount(Math.abs(faceAmt))} {isIncrease ? '올랐' : '내렸'}
                </em>
                어요
            </p>
        </InsuranceDetailHeadLineArticleWrapper>
    )
}

export const InsuranceCarCoverageBox = ({endDate}: {endDate: string}) => {
    return (
        <InsuranceDetailHeadLineArticleWrapper>
            <p className={cx('text')}>
                <em className={cx('emphasis')}>{endDate}까지 보장</em>
                <br />
                받을 수 있습니다.
            </p>
        </InsuranceDetailHeadLineArticleWrapper>
    )
}

export const InsuranceCarCoverageEndBox = ({endDate}: {endDate: string}) => {
    return (
        <InsuranceDetailHeadLineArticleWrapper>
            <p className={cx('text')}>
                <em className={cx('emphasis')}>{endDate}에 보장이 종료</em>되었습니다.
            </p>
        </InsuranceDetailHeadLineArticleWrapper>
    )
}
